import { createApp } from 'vue'
import App from './App.vue'
import vuetify from "@/plugins/vuetify";


const app = createApp(App);

app.use(vuetify); // Vuetify 등록
app.mount('#app');